// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3xSoX","validationTips":"StatementDescriptor_validationTips__2vQwN"};